module.exports = {
      id: "icon-audio-previous-usage",
      viewBox: "0 0 35.504 35.504",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-audio-previous",
      toString: function () {
        return this.url;
      }
    }